import styled from 'styled-components'
import { Box, ResponsiveText, Text } from '@usap/uicomponents'

export const CouponsMainContainer = styled(Box)`
  background: url('${({ bgImage }) => bgImage || ''}') no-repeat fixed center;
  background-size: cover;
  margin: 0 auto;
  height: 700px;
  justify-content: center;
  padding: 0;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    height: auto;
    padding: 24px 8px;
  }
`

export const CouponsInnerContainer = styled(Box)`
  background-color: rgba(255, 255, 255, 0.8);
  padding: 40px;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    padding: 16px;
  }
`

export const CouponsFooterContainer = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    flex-direction: column;
    justify-content: center;
  }
`

export const CouponsFooterInnerContainer = styled(Box)`
  align-items: flex-start;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    align-items: center;
  }
`

export const CouponsTextPointer = styled(ResponsiveText)`
  cursor: pointer;
  white-space: nowrap;
  padding: 0 0 0 3px;
  text-align: start;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    padding: 0 0 0 0;
    text-align: center;
  }
`

export const CouponsPrivacyContainer = styled(Box)`
  align-items: flex-start;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    align-items: center;
  }
`

export const CouponsContinueShoppingContainer = styled(Box)`
  align-items: flex-end;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    align-items: center;
  }
`

export const ContinueShoppingText = styled(Text)`
  padding-bottom: 32px;
  text-align: end;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    padding-bottom: 0;
    text-align: center;
  }
`
